import { NOT_SET, VENDOR } from '../constants'

export class GtmFacade {
  constructor(gtm, gaApp) {
    this.module = gtm
    this.gaApp = gaApp
  }

  get entity() {
    return VENDOR.GTM
  }

  get CONSTANTS() {
    return {
      NOT_SET,
    }
  }

  init(id) {
    if (!this.module) {
      throw new Error(`Модуль ${this.entity} отсутствует`)
    }

    const identificator = id || this.gaApp.config.get(VENDOR.GTM)?.id

    return this.module.create(identificator)
  }

  send(...args) {
    if (!this.module) {
      throw new Error(`Модуль ${this.entity} отсутствует`)
    }

    const push = () => this.module.push(...args)

    return this.gaApp.services.app.scheduler.postTask(push, 'background')
  }
}
